import ManagerDashboardUpdateDto from "../../../types/dtos/dashboards/ManagerDashboardUpdateDto";
import { ClientTaskType } from "../../../types/dtos/tasks/advanced-tasks/ClientTaskType";
import { TFunction } from "i18next";

/**
 * Whether an update belongs on the manager dashboard "To Do" tab (and the employee homepage team widget).
 * Keep in sync with UpdatesWidget filtering.
 */
export function isManagerTodo(update: ManagerDashboardUpdateDto): boolean {
  return (
    update.updateType !== "ADVANCED-TASKS-UPDATED-BY-EMPLOYEE" &&
    (update.needsManagerAttention || update.updateType === "DUAL-PREP-MEETING")
  );
}

export function filterManagerTodos(
  updates: ManagerDashboardUpdateDto[]
): ManagerDashboardUpdateDto[] {
  return updates.filter(isManagerTodo);
}

export function sortManagerTodosByNewest(
  updates: ManagerDashboardUpdateDto[]
): ManagerDashboardUpdateDto[] {
  return [...updates].sort(
    (a, b) =>
      new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  );
}

export function managerUpdateUsesCollabDocLink(
  update: ManagerDashboardUpdateDto
): boolean {
  return (
    update.updateType === "COLLAB-DOC" ||
    update.updateType === "GENERAL-CATCH-UP" ||
    update.updateType === "DUAL-PREP-MEETING" ||
    (update.updateType === "DUAL-PREP-PLANNING" &&
      update.answerSetUniqueId !== null)
  );
}

export function getManagerTodoDescriptorBadgeText(
  update: ManagerDashboardUpdateDto,
  t: TFunction,
  taskType?: ClientTaskType
): string {
  switch (update.updateType) {
    case "COLLAB-DOC":
    case "DUAL-PREP-MEETING":
      if (
        update.approvalFlow !== null &&
        update.approvalFlow === "HIDDEN-TO-EMPLOYEE"
      ) {
        return "Review";
      }
      return "Meeting";
    case "DUAL-PREP-PLANNING":
      return "Planning";
    case "GENERAL-CATCH-UP":
      return "Catch Up";
    case "ADVANCED-TASKS-UPDATED-BY-EMPLOYEE":
      if (update.advancedTaskTypeId && taskType) {
        return t(taskType.pluralNameTranslationKeyIdentifier);
      }
      return "";
    default:
      return "";
  }
}
